// material-ui
import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';

// project imports
import { DRAWER_WIDTH } from 'config';

const openedMixin = (theme) => ({
  width: DRAWER_WIDTH,
  borderRight: 'none',
  background: 'linear-gradient(180deg, #fafcfb 0%, #f3f8f5 100%)',
  boxShadow: '4px 0 32px rgba(15, 45, 32, 0.05)',
  borderRight: '1px solid rgba(31, 91, 64, 0.08)',

  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.easeInOut,
    duration: 280
  }),

  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.easeInOut,
    duration: 280
  }),

  overflowX: 'hidden',
  width: theme.spacing(7.5),
  borderRight: 'none',
  background: 'linear-gradient(180deg, #fafcfb 0%, #f3f8f5 100%)',
  boxShadow: '4px 0 32px rgba(15, 45, 32, 0.05)',
  borderRight: '1px solid rgba(31, 91, 64, 0.08)',
});

// ==============================|| DRAWER - MINI STYLED ||============================== //

const MiniDrawerStyled = styled(Drawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
  width: DRAWER_WIDTH,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme)
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme)
  })
}));

export default MiniDrawerStyled;
